module.exports = __webpack_public_path__ + "static/media/vinsen.5d85546a.png";